import React, { useState, useEffect } from "react";
import axios from "axios";

const InputField = (props) => {

    const [currentValue, setCurrentValue] = useState('');
    const intern = document.getElementById('intern').value ?? 'www.stadtwerke-hamm.de';
    const internPlz = ['59063','59065','59067','59069','59071','59073','59075','59077'];
    let timer;

    // Check if internal/external and send a request to the plz-api
    useEffect(() => {
        if(currentValue) {
            let match = internPlz.includes(currentValue);

            if(document.location.host === intern) {
                if(!match) {
                    props.setShowError(true);
                    props.setErrorText('Die eingegebene Postleitzahl liegt nicht in Hamm. Energieprodukte für Gebiete außerhalb von Hamm finden Sie hier: <a href="https://www.hammer-energie.de">www.hammer-energie.de</a>');
                    props.setDisableButton(true);
                }
                else {
                    checkAvailability();
                }
            }
            else {
                if(match) {
                    props.setShowError(true);
                    props.setErrorText('Energieprodukte für Postleitzahlen in Hamm finden Sie hier: <a href="https://www.stadtwerke-hamm.de">www.stadtwerke-hamm.de</a>');
                    props.setDisableButton(true);
                }
                else {
                    checkAvailability();
                }
            }
        }
    }, [currentValue])

    const updateValue =(e)=> {
        clearTimeout(timer);
        // Sets new timer that may or may not get cleared
        timer = setTimeout(() => {
            props.setDisableButton(true);
            if(e.target.value.length === 5)
                setCurrentValue(e.target.value)
        }, 1000);
    }

    const checkAvailability =()=> {
        axios({
            method: 'post',
            url: 'https://onlineservice.stadtwerke-hamm.de/internetportal/auth/oauth/token',
            data: {
                grant_type: 'password',
                username: 'anonymous',
                scope: 'read+write',
                locale: 'de_DE'
            },
            auth: {
                username: 'uonline',
                password: 'swhamm2025!'
            },
            headers:{
                'Content-Type':'multipart/form-data'
            }
        })
        .then((response)=> {
            axios({
                method: 'get',
                url: 'https://onlineservice.stadtwerke-hamm.de/internetportal/rest/api/v1/supplyAreas',
                headers:{
                    'Authorization':'Bearer '+response.data.access_token
                },
                params: {
                    postalCode: currentValue,
                    mediaType: props.type,
                }
            })
            .then((response) => {
                props.setDisableButton(false);
                if(response.data.length === 0) {
                    props.setShowError(true);
                    props.setErrorText('Für diese PLZ konnten wir leider kein Angebot finden.');
                    props.setDisableButton(true);
                }
            })
        });
    }

    return <div className="form-group">
        <label className="floating" htmlFor={props.name}>{props.placeholder}</label>
        <input placeholder={props.placeholder}
               className="form-control uoValidateOnChange validateEmpty validateGreaterThanZero"
               type="number" name={props.name}
               autoComplete="off"
               id="plz"
               onChange={ (e) => updateValue(e)}
        />
    </div>
}

export default InputField;